const jobs = {
  bulk: {
    table: {
      direction: {
        to: 'Distribute',
        from: 'Collect',
        both: 'Collect / Distribute',
      },
    },

    direction: {
      label: 'Direction',
      to: 'To Work',
      from: 'From Work',
      both: 'To Work & From Work',
    },

    form: {
      information: {
        passengers: {
          header: 'Select Employees',
          fields: {
            passengers: 'Employees',
          },
        },

        details: {
          fields: {
            direction: 'Select Direction',
            shift: 'Working Hours',
            from: 'Home',
            to: 'Work',
            fromHour: 'Shift Start At',
            toHour: 'Shift Ends At',
          },
        },
        locations: {
          header: 'Workplace',
          fields: {
            locations: 'Select Workplace'
          }
        },
      },
    },
  },
};

export default jobs;
